import React from 'react';
import type { Migration } from '../../../types';

interface DeleteModalContentProps {
  job: Migration;
}

export const DeleteModalContent: React.FC<DeleteModalContentProps> = ({ job }) => {
  return (
    <>
      <p className="text-base text-gray-700 dark:text-gray-300 text-center mb-1">
        Are you sure you want to delete{' '}
        <span className="font-semibold text-red-600 dark:text-red-500">{job.name}</span>?
      </p>
      <p className="text-sm text-blue-600 dark:text-blue-400 text-center">
        You will permanently delete the configuration from the Migrator Database.
      </p>
    </>
  );
};
